import { render, staticRenderFns } from "./SpacesList.vue?vue&type=template&id=5268b200"
import script from "./SpacesList.vue?vue&type=script&lang=ts"
export * from "./SpacesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports